import { useAccount } from "wagmi";
import { ReactComponent as WalletUnconnectedIcon } from "../../../img/trade-history/wallet-unconnected.svg";
import { GlobalStore } from "../../../store/global/GlobalStore";
import { UserIconImage } from "./elements/UserIconImage";
import { WalletIconToDisplay } from "../WalletIconToDisplay/WalletIconToDisplay";

export interface UserIconProps {
  borderRadius?: number | string;
  size?: number;
  withBackground?: boolean;
}

export const UserIcon: React.FC<UserIconProps> = ({
  size = 31,
  borderRadius = 14,
  withBackground = false,
}) => {
  const avatar = GlobalStore.useState(s => s.ensAvatar);
  const zerionNft = GlobalStore.useState(s => s.zerionNft);
  const { address, connector } = useAccount();

  if (!address) {
    return <WalletUnconnectedIcon width={size} height={size} />;
  }

  if (avatar) {
    return (
      <UserIconImage borderRadius={borderRadius} src={avatar} size={size} alt={"ENS Avatar"} />
    );
  }

  if (zerionNft) {
    return (
      <UserIconImage borderRadius={borderRadius} src={zerionNft} size={size} alt={"Zerion NFT"} />
    );
  }

  return (
    <WalletIconToDisplay
      connector={connector}
      options={{
        size,
        withBackground: withBackground,
        borderRadius: borderRadius,
      }}
    />
  );
};
